// src/components/ComprehensiveSection.js
import React from 'react';
import './ComprehensiveSection.css';
import { useLocation } from 'react-router-dom';

const ComprehensiveSection = ({ blockData }) => {

  const location = useLocation();

  let sectionMargin = "-190px"

  if (location.pathname === '/demo') {
    sectionMargin = "50px"
  }

  return (
    <section id="comprehensiveSection" className="comprehensive-section" style={{marginTop: sectionMargin}}>
      {/* Key Benefits Subsection */}
      <div className="key-benefits">
        <h5>The Comprehensive Digital EcoSystem for Independent Practices</h5>
      </div>

      {/* Main Heading and Text */}
      <div className="comprehensive-section-content">
        <h2 className="main-heading">Empowering the Future-Ready Connected Practice</h2>
        <p className="text">Stay ahead of your practice's needs, from new patient acquisition and care delivery to patient experience and billing.</p>
      </div>

      {/* Dynamic Blocks */}
      <div className="blocks-container">
        {blockData.map((block, index) => (
          <div className="block" key={index}>
            <img src={block.logo} alt={`Block ${index + 1} Logo`} className="block-logo" />
            <h3>{block.title}</h3>
            <p>{block.text}</p>
            <a href={block.link} className="learn-more-btn">
              Learn More  →
            </a>
          </div>
        ))}
      </div>
    </section>


  );
};

/*
const WhyDoclivo = () => {
  return (
    <section id="whyDoclivo" className="why-doclivo-section">
      
      <div className="key-benefits">
        <h3>Key Benefits</h3>
      </div>

      
      <div className="why-doclivo-content">
        <h2 className="main-heading">Why Doclivo</h2>
        <p className="centered-text">
          The premier practice automation platform, enhancing patient experience, provider well-being, and overall practice efficiency
        </p>
      </div>

      
      <div className="benefits-container">
        <div className="benefit-block">
          <img src={accordion1} alt="Benefit 1" />
          <h5>1. Deliver better care</h5>
          <h3>Focus your time on what truly matters.</h3>
          <p>Enable each provider in your practice to concentrate on their core strengths and well-being by offering clinical tools that support rather than hinder patient care delivery. Ensure patients receive the attention they deserve and enable comprehensive care through a holistic understanding of their health</p>
        </div>

        <div className="benefit-block">
          <img src={accordion2} alt="Benefit 2" />
          <h5>2. Enhance your patient experience</h5>
          <h3>Ensure ongoing involvement & interaction</h3>
          <p>Meet heightened patient expectations by consistently offering convenient digital touchpoints. Implement online scheduling, appointment reminders, custom intake forms, and text messaging to create a positive experience, fostering patient loyalty and encouraging return visits to your practice.</p>
        </div>

        <div className="benefit-block">
          <img src={accordion3} alt="Benefit 3" />
          <h5>3. Manage records digitally</h5>
          <h3>Digitally manage patient records</h3>
          <p>Get everything your practice needs, from appointments, streamlined patient documentation, electronic medical records, to a comprehensive view of the patient and their history, eRx, eLabs,and more</p>
        </div>
      </div>
    </section>
  );
};
*/

export default ComprehensiveSection;
